import { cacheExchange } from '@urql/exchange-graphcache'
import { TemplatesDocument } from '~~/graphql/operations'

const excludeCacheKeys = [
  'File',
  'Meta',
  'ProductText',
  'ChannelPaginated',
  'LanguagePaginated',
  'PromotionPaginated',
  'ProductPaginated',
  'StockPoolPaginated',
  'TemplatePaginated',
  'TaxPaginated',
  'CurrencyPaginated',
  'ExportPaginated',
  'ProductReviewPaginated',
  'ManufacturerPaginated',
  'ProductFilterPaginated',
  'CarrierPaginated',
  'AttributeGroupPaginated',
  'FlagPaginated',
  'CountryPaginated',
  'MaterialSamplePaginated',
  'OrderStatusPaginated',
  'OrderItemPaginated',
  'CouponPaginated',
  'CategoryPaginated',
  'ModuleGroupsPaginated',
  'ProductFamilyPaginated',
  'DeliveryMethodPaginated',
  'ShowroomPaginated',
  'StyleImage',
  'StyleImagePaginated',
  'LinksPaginated',
  'MenuPaginated',
  'StaticSiteUrlPaginated',
  'PartnerPaginated',
  'CampaignPaginated',
  'ImportPaginated',
  'PagePaginated',
  'TagPaginated',
  'PromotionBarPaginated',
  'ManufacturerMetricPaginated',
  'ManufacturerMetric',
  'ManufacturerDeliveryPaginated',
  'PaymentMethodPaginated',
  'CouponOrderCount',
  'PerformanceStockPaginated',
  'AssistantAiProductDataPaginated',
  'OrderStatisticsSummary',
  'OrderStatisticsSummaryItem',
  'OrderStatisticsTimeseries',
  'OrderStatisticsTimeseriesItem',
  'InspirationPaginated',
  'UserPaginated',
  'SingleStatAnalyticValue',
  'OrderPaginated',
  'ManufacturerText',
  'ManufacturerMarginPaginated',
  'ProductFilterResultPaginated',
  'CustomerPaginated',
  'LoyaltyLevelsPaginatedEntity',
  'CustomerGroupPaginated',
  'CustomerLoyaltyHistory',
  'LoyaltyLevelsEntity',
  'FrontendProductFilterOptionItem',
  'JobPaginated',
  'StockSourceFilePaginated',
  'StockSourceFileDownloadPaginated',
  'ProductPrice',
  'ChannelSitemapPaginated',
  'UserOrderDataAutofill',
  'DeliveryServicesPaginated',
  'AttributeGroupText',
  'AttributePaginated',
  'AttributeGroup',
  'DeliveryMethodService',
  'CategoryMappingPaginated',
  'CacheNamespace',
  'AttributeValueText',
  'ProductAttributeValue',
  'CollectionPaginated',
  'DhlAddress',
  'AuthorPaginated',
  'InspirationProduct',
  'ProductConfiguratorGroupPaginated',
  'MutationResolution',
  'FrontendIndexedProductsByCategory',
  'TranslationDashboard',
  'TranslationSettings'
]

export const CacheExchange = cacheExchange({
  keys: excludeCacheKeys.reduce(
    (acc, name) => ({
      ...acc,
      [name]: () => null,
    }),
    {},
  ),
  updates: {
    Mutation: {
      // createTemplate(result: any, args, cache, info) {
      //   cache
      //     .inspectFields("Query")
      //     .filter((field) => field.fieldName === "templates")
      //     .forEach((field) => {
      //       cache.updateQuery(
      //         {
      //           query: TemplatesDocument,
      //           variables: {
      //             where: field.arguments.where as object,
      //             page: field.arguments.page as number,
      //             perPage: field.arguments.perPage as number,
      //           },
      //         },
      //         (data) => {
      //           if (data.templates.data.length < 10)
      //             data.templates.data.push(result.createTemplate);
      //           return data;
      //         }
      //       );
      //     });
      // },
    },
  },
})
